
  import { Component, Vue } from 'vue-property-decorator';
  import tokenService from '@/services/token.service';

  @Component
  export default class Logout extends Vue {
    created() {
      tokenService.logOut(this, this.$route.query["id-user"] ? this.$route.query["id-user"].toString() : undefined);
    }
  }
